import React from 'react';
import {Dialog, Typography, Button, DialogTitle, DialogActions} from '@material-ui/core';
import { Link } from 'react-router-dom';

export default function DialogTimer(props) {

    //console.log('expired:', props.expired)
    
  return (
        <Dialog open className="dialog-timer">
            <DialogTitle disableTypography className="text-center">
                <Typography variant="h3" className='mt-1 title-dialog-timer'>¡Tu búsqueda ha expirado!</Typography></DialogTitle>
                <DialogActions className="align-center">
                    <Button className='mb-1' color="primary" variant="contained" size="small"
                        //href={props.redirect} 
                        component={Link} 
                        to={`/${props.tokenClient}/trenes/`}
                    >Volver al inicio</Button>
                   
                </DialogActions>  
      </Dialog>
  );
}
